import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > :first-child {
    margin-bottom: 0;
  }
`;

export const BodyWrapper = styled.div`
  margin-top: 24px;
`;
